import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AutocompleteMaterial from '@material-ui/lab/Autocomplete';
import { fade } from "@material-ui/core/styles/colorManipulator";

const StyledAutocomplete = withStyles((theme) => ({
  paper: {
    borderRadius: 0
  },
  inputRoot: {
    border: `1px solid ${theme.palette.grey[300]}`,
    overflow: "hidden",
    borderRadius: 0 + "!important",
    backgroundColor: `${theme.palette.background.default} !important`,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    paddingTop: theme.spacing(0.4) + "px!important",
    paddingBottom: theme.spacing(0.4),
    "&:hover": {
      backgroundColor: theme.palette.background.paper
    },
    "&$focused": {
      backgroundColor: theme.palette.background.paper,
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main
    },
  }
}))(AutocompleteMaterial)

const Autocomplete = (props) => {
  const { background = "default", ...rest } = props
  return (<>
    {background === "light" ? <StyledAutocomplete {...rest} /> : <AutocompleteMaterial {...rest} />}

  </>
  );
}

export default Autocomplete;